import React, { Fragment, useState, useRef } from 'react'
import useStyles from './styles'
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Collapse,
  FormHelperText,
  Tooltip
} from '@material-ui/core'
import SentimentSatisfiedIcon from '@material-ui/icons/SentimentSatisfied'
import 'emoji-mart/css/emoji-mart.css'
import { Picker } from 'emoji-mart'
import { Formik, Form } from 'formik'
import LoaderButton from 'components/LoaderButton'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import { sendMessage } from 'actions/event'
import { isEmpty } from 'lodash'
import { openLoginDialog } from 'actions/login-dialog'

const Schema = Yup.object().shape({
  text: Yup.string()
    .max(225, 'The maximum message length is 255 characters')
    .required('Text is required')
})

const ChatBar = ({ children }) => {
  const classes = useStyles()

  const dispatch = useDispatch()

  const auctionCode = useSelector(state => state.event.event.auction_code)
  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )

  const inputRef = useRef(null)

  const [emojiPickerOpen, setEmojiPickerOpen] = useState(false)
  const [postError, setPostError] = useState('')

  const handleClickEmojiButton = () => {
    setEmojiPickerOpen(!emojiPickerOpen)
  }

  const handleEmojiSelected = (emoji, values, setFieldValue) => {
    setFieldValue('text', `${values.text || ''}${emoji.native} `)
    setTimeout(() => {
      inputRef.current.scrollLeft = inputRef.current.scrollWidth * 2
    }, 50)
  }

  const postMessage = (values, actions, response) => {
    dispatch(
      sendMessage(auctionCode, {
        body: values.text,
        user_id:
          response !== undefined ? response.user_id : authenticatedUser.user_id,
        eid: auctionCode
      })
    )
      .then(() => {
        actions.resetForm()
        setPostError('')
      })
      .catch(err => {
        setPostError(err.error)
      })
      .finally(() => actions.setSubmitting(false))
  }

  const handleSubmitChat = (...args) => {
    setEmojiPickerOpen(false)
    if (isEmpty(authenticatedUser)) {
      dispatch(openLoginDialog())
        .then(response => {
          postMessage(...args, response)
        })
        .fail(() => {
          args[1].setSubmitting(false)
        })
    } else {
      postMessage(...args)
    }
  }

  return (
    <Box className={classes.chatBar}>
      <Formik
        initialValues={{ text: '' }}
        validationSchema={Schema}
        onSubmit={handleSubmitChat}
      >
        {({ isSubmitting, values, errors, handleChange, setFieldValue }) => (
          <Fragment>
            <Box className={classes.emojiPicker}>
              <Collapse
                in={emojiPickerOpen}
                classes={{
                  container: classes.emojiPickerContainer,
                  wrapper: classes.emojiPickerWrapper,
                  wrapperInner: classes.emojiPickerWrapperInner
                }}
              >
                <Picker
                  showPreview={false}
                  showSkinTones={false}
                  onSelect={emoji =>
                    handleEmojiSelected(emoji, values, setFieldValue)
                  }
                  style={{
                    width: '100%',
                    height: '100%',
                    maxHeight: 'calc(100vh - 88px)'
                  }}
                />
              </Collapse>
            </Box>
            <Tooltip
              open={errors.text !== '' || postError !== ''}
              title={errors.text || postError}
            >
              <Form className={classes.form} autocomplete="off">
                <input
                  autoComplete="false"
                  name="hidden"
                  type="text"
                  style={{ display: 'none' }}
                />
                <Box display="flex">
                  <TextField
                    id="sendCommentTextOne"
                    name="text"
                    variant="outlined"
                    className={classes.chatTextField}
                    placeholder="Send a comment"
                    value={values.text}
                    error={errors.text !== undefined || postError !== ''}
                    onChange={handleChange}
                    onFocus={() => setEmojiPickerOpen(false)}
                    InputProps={{
                      inputProps: {
                        ref: inputRef
                      },
                      classes: {
                        root: classes.inputRoot,
                        input: classes.inputInput
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            id="emojiSelectorOne"
                            className={classes.emojiButton}
                            size="small"
                            aria-label="toggle password visibility"
                            onClick={handleClickEmojiButton}
                            edge="end"
                          >
                            <SentimentSatisfiedIcon />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                  <LoaderButton
                    id="sendMessageOne"
                    type="submit"
                    variant="contained"
                    classes={{ button: classes.submitButton }}
                    working={isSubmitting}
                    classoverrides={{
                      button: {
                        root: classes.sendButton
                      }
                    }}
                  >
                    Send
                  </LoaderButton>
                </Box>
              </Form>
            </Tooltip>
          </Fragment>
        )}
      </Formik>
    </Box>
  )
}

export default ChatBar



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/ChatBar/index.jsx